<template>
    <div>
        <le-search-form @reset="handlerRest" @search="handlerSearch" >
            <le-input label="订单编号" v-model="pageParam.params.id" placeholder="请输入订单编号" />
            <le-date-range 
                label="操作时间" 
                :minDate.sync="pageParam.params.startTime" 
                :maxDate.sync="pageParam.params.endTime" 
                valueFormat="yyyy-MM-dd HH:mm:ss" 
                :defaultTime="['00:00:00','23:59:59']" />
        </le-search-form>
        <le-pagview ref="redpackageGet" @setData="setTableData" :pageParam="pageParam" v-if="pageParam">
            <el-table :data="tabledata">
                <el-table-column label="订单编号" prop="typeText">
                    <template slot-scope="{ row }">
                        <span>{{ row.id || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="赠送金额" prop="content">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.changeAmount) }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="已消耗" prop="orderId">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.payAmount) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="剩余金额" prop="activePower">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.payAmount) }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="商户" prop="operatorUserPhone">
                    <template slot-scope="{ row }">
                        <span>{{ row.companyName || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="备注" prop="cardNo">
                    <template slot-scope="{ row }">
                        <span>{{ row.remark || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作时间" prop="createTimeText">
                    <template slot-scope="{ row }">
                        <span>{{ row.createTime || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作人" prop="createTimeText">
                    <template slot-scope="{ row }">
                        <span>{{ row.userName || '-' }} {{ row.userPhone || '-' }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </le-pagview>
    </div>
</template>

<script>
    import util from '@/utils/util.js'
    export default {
        data() {
            return {
                util: util,
                pageParam: {
                    url: this.$Config.apiUrl.userRedPackAddPage,
                    method: "post",
                    params: {
                        "endTime": "",
                        "id": "", // 订单编号
                        "startTime": "",
                        "userId": this.userId
                    },
                    freshCtrl: 1,
                },
                tabledata: [],
            }
        },
        props:['userId','phone'],
        mounted () {

        },
        methods:{
            handlerRest() {
                this.pageParam.params = {
                    "endTime": "",
                    "id": "", // 订单编号
                    "startTime": "",
                    "userId": this.userId
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs.redpackageGet.pageNum = 1
                this.pageParam.freshCtrl++;
            },
            setTableData (datas) {
                this.tabledata = datas.map(item=>{
                    return {
                        ...item,
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
   
</style>